import React from "react";
import CpvMyActions from '@/pages/quality/cpv/CpvMyActions';

// ==============================|| NOTIFICATION PAGE ||============================== //

/** The bell's "View all": the same CPV acts waiting on the signed-in person (GET /bp/cpv/my-actions/). */
const NotificationPage = () => <CpvMyActions />;

export default NotificationPage;
